export class DadosIsoFugModel  {

     public descRetorno : string;
     public icPerfil : string;
     public codRetorno : string;
}


export class EntradaIsoFugModel  {

    public inscricao: string;
    public perfilSelecionado: number;
}

